import React, { FC } from 'react';

import Button from '../../../common/button';
import ModalWrap from '../../../common/modal-wrap';
import { CloseCrossBtn } from '../../../icons/close-cross-btn';

interface IProtocolModalProps {
  isShow: boolean;
  onClose: () => void;
}

const ProtocolModal: FC<IProtocolModalProps> = ({ isShow, onClose }) => {
  return (
    <ModalWrap isShow={isShow}>
      <div className="relative flex w-[min(420px,90vw)] flex-col items-center gap-5 rounded-[24px] bg-white p-6 text-center shadow-shadowPopup">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-grey1 transition-colors hover:bg-grey2"
          aria-label="Закрыть модальное окно"
        >
          <CloseCrossBtn width={16} height={16} />
        </button>
        <h2 className="mt-2 font-comfortaa text-xl font-bold text-blackBase">Протоколы</h2>
        <p className="text-sm text-greyBase">
          Раздел находится в разработке. Мы сообщим, когда функция будет доступна.
        </p>
        <Button type="primary" className="!w-full !py-2.5 !text-base" onClick={onClose}>
          Понятно
        </Button>
      </div>
    </ModalWrap>
  );
};

export default ProtocolModal;
